import React, {Component} from 'react';
import IconButton from '@mui/material/IconButton';
import {withStyles} from '@mui/styles';
import PropTypes from 'prop-types';
import Tooltip from '@mui/material/Tooltip';
import ShareDialog from "../collaborate/ShareDialog";

const styles = theme => ({});

const INITIAL_STATE = {
    showDialog: false,
};

class ShareButton extends Component {

    constructor(props) {
        super(props);
        this.state = INITIAL_STATE;
        this.handleCloseDialog = this.handleCloseDialog.bind(this);
    }


    handleClickIcon = (event) => {
        this.setState({
            showDialog: true
        });

    };

    handleCloseDialog = () => {
        this.setState({
            showDialog: false
        });

    };

    render() {

        const { anchorEl } = this.state;

        return (
            <React.Fragment>
                <Tooltip title={this.props.actionConfig.label}>
                    <IconButton
                        aria-label="Menu"
                        aria-owns={anchorEl ? 'simple-menu' : undefined}
                        aria-haspopup="true"
                        color = "secondary"
                        onClick={this.handleClickIcon}
                        size="medium">
                        <i className='material-icons'>
                            {this.props.actionConfig.icon}
                        </i>
                    </IconButton>
                </Tooltip>

                {
                    (this.state.showDialog) &&
                    <ShareDialog
                        boxId={this.props.boxId}
                        userDetails={this.props.userDetails}
                        handleCloseDialog={this.handleCloseDialog}
                        triggerRefreshAuthToken={this.props.triggerRefreshAuthToken}
                        type={this.props.type}
                    />
                }
            </React.Fragment>
        );
    }
}

ShareButton.propTypes = {
    actionConfig: PropTypes.object.isRequired,
    boxId: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    userDetails: PropTypes.object.isRequired,
    triggerRefreshAuthToken: PropTypes.func.isRequired
};

export default withStyles(styles)(ShareButton);